
function singleObserverCallback(entries, observer) { entries.forEach((entry) =>
{
  if (entry.isIntersecting) {
    entry.target.classList.toggle('load-animation');
    observer.unobserve(entry.target);
  }
}); }

function synchronizedObserverCallback(entries, observer) { entries.forEach((entry) =>
{
  if (entry.isIntersecting) {
    const animatedChildrens = entry.target.querySelectorAll('[data-js-animation-order]');
    let firstToAnimate = animatedChildrens[0].dataset.jsAnimationOrder === "1" ? animatedChildrens[0] : animatedChildrens[1];
    let secondToAnimate = animatedChildrens[1].dataset.jsAnimationOrder === "2" ? animatedChildrens[1] : animatedChildrens[0];
    firstToAnimate.addEventListener('transitionend', function (e)  {
      if(!this.classList.contains('load-animation'))
        this.classList.add('load-animation');
    }.bind(secondToAnimate))
    firstToAnimate.classList.toggle('load-animation');
    observer.unobserve(entry.target);
  }
}); }

Drupal.behaviors.siteAnimations = {
  attach: function (context, settings) {
    once('amrestAnimations', '.js-animation', context).forEach(function (element) {
      const elementClasses = element.classList;
      if (elementClasses.contains("js-inner-animation")) {
        const animatedInner = element.querySelector('.inner');
        let singleObserver = new IntersectionObserver(singleObserverCallback);
        singleObserver.observe(animatedInner);
      } else if (elementClasses.contains("js-synchronized-animation")) {
        let synchronizedObserver = new IntersectionObserver(synchronizedObserverCallback);
        synchronizedObserver.observe(element);
      } else {
        let singleObserver = new IntersectionObserver(singleObserverCallback);
        singleObserver.observe(element);
      }
    });
  },
};
